import React from "react";
import { useUseGetFancyDimondsQuery } from "../../../store/api/filterApi";
import IcDimond from "../../../assets/icons/IcDimond";
import { useDispatch, useSelector } from "react-redux";
import {
  removeFromFilter,
  updateFilter,
} from "../../../store/slices/filterSlice";
import Loader from "../../common/Loader";

const FancyColor = () => {
  const { data: fancyColorData, isLoading: fencyColorLoading } =
    useUseGetFancyDimondsQuery();
  const dispatch = useDispatch();
  const filterSelect = useSelector((state) => state?.filter);
  const handleAddFilter = (value) => {
    dispatch(updateFilter({ key: "color", value: value.toString() }));
  };
  const handleRemoveFilter = (value) => {
    dispatch(removeFromFilter({ key: "color", value: value.toString() }));
  };
  return (
    <div className="mt-3">
      <div className="fancy-color-range position-relative">
        {fencyColorLoading && (
          <div
            style={{
              height: "84px",
            }}
          >
            <Loader />
          </div>
        )}
        {fancyColorData?.data?.map((item) => {
          return (
            <div
              key={item?.id}
              className={`fancy-color-item ${
                filterSelect?.color?.includes(item?.name?.toString())
                  ? "active"
                  : ""
              }`}
              onClick={() =>
                filterSelect?.color?.includes(item?.name?.toString())
                  ? handleRemoveFilter(item?.name)
                  : handleAddFilter(item?.name)
              }
            >
              <div className="image-section">
                <IcDimond fill={item?.color_code} height={20} width={25} />
              </div>

              <div className="name">{item?.name}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FancyColor;
